// PsyPractice: hukuki belgeler / Svenska.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "Enskild firma";

const OWNER = 'PsyPractice (nedan ”Plattformen” eller ”den Personuppgiftsansvarige”)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Användarvillkor och ansvarsfriskrivning",
    description:
      "Tjänstens karaktär och gränser, vad den inte ersätter, Användarens åtaganden samt en omfattande ansvarsfriskrivning som lägger allt ansvar på Användaren.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Parter och godkännande",
        paras: [
          `Dessa Användarvillkor ingås mellan ${OWNER} och varje fysisk eller juridisk person som får åtkomst till eller använder Plattformen (”Användaren”). Genom att skapa ett konto, logga in eller använda Plattformen på något sätt bekräftar Användaren att hen har läst, förstått och villkorslöst godkänner och åtar sig att följa dessa Villkor i sin helhet. Den som inte godkänner dessa Villkor får inte använda Plattformen.`,
        ],
      },
      {
        heading: "2. Tjänstens karaktär och gränser",
        bullets: [
          "PsyPractice är en AI-stödd programvara för SIMULERING av patienter som låter psykologstudenter och kliniker i början av karriären genomföra och dokumentera sin egen samtalsövning i en trygg miljö.",
          "PsyPractice är inte en utbildnings- eller undervisningstjänst; det är ett programvaruverktyg som låter Användaren genomföra och dokumentera sin egen övning. Plattformen tillhandahåller inga lektioner, ingen läroplan, inga examinationer och inga dokument, och ger inte någon som helst titel, kvalifikation eller behörighet.",
          "Den simulerade ”patienten” är inte en verklig klient; dess svar syntetiseras av artificiell intelligens, kan vara felaktiga, ofullständiga, motsägelsefulla eller vilseledande, och gör inga anspråk på klinisk riktighet eller sanning.",
        ],
      },
      {
        heading: "2.1. Vad Plattformen inte ersätter",
        bullets: [
          "Den är INTE verklig terapi eller rådgivning, och den ersätter ingen session som genomförs med en verklig klient.",
          "Den är INTE en ersättning för klinisk handledning. Återkopplingsrapporter som produceras av handledar-AI:n är automatiskt genererad text; de är inte expertutlåtanden, officiella bedömningar eller betyg.",
          "Den är INTE ett diagnostiskt instrument, ett screeninginstrument eller ett bedömningsinstrument; inget resultat från Plattformen får användas för diagnostik eller kliniskt beslutsfattande om någon verklig person.",
          "Den FÅR INTE användas i kriser eller nödsituationer. Vid suicidtankar, risk för skada på dig själv eller andra, eller någon jämförbar nödsituation: stäng Plattformen och kontakta omedelbart din lokala räddningstjänst eller en behörig vårdinrättning.",
          "Den är INTE en källa till yrkeskompetens, legitimation, titel eller behörighet; tid som tillbringats på Plattformen och dess resultat får inte visas upp för någon institution som bevis på kvalifikation.",
        ],
      },
      {
        heading: "3. Användarens försäkringar och åtaganden",
        bullets: [
          "Användaren åtar sig att använda Plattformen enbart inom lagliga och etiska gränser, i syfte att utveckla sin egen yrkesutövning.",
          "Användaren förbinder sig att INTE mata in några VERKLIGA patient- eller klientuppgifter, identifierande uppgifter eller känsliga hälsouppgifter som tillhör någon person; alla rättsliga följder av att göra det vilar uteslutande på Användaren.",
          "Användaren åtar sig att inte använda något resultat från Plattformen för diagnostik, behandling, intervention eller kliniskt beslutsfattande rörande någon verklig person.",
          "Användaren är ensam ansvarig för sin egen yrkeskompetens, sitt behörighetsområde och sin efterlevnad av tillämpliga yrkesmässiga och etiska regler.",
          "Kontosäkerhet, lösenordets konfidentialitet och all aktivitet som utförs under Användarens konto är Användarens ansvar.",
          "Kontot är personligt; Användaren åtar sig att inte dela det med andra och att inte använda Plattformen med automatiserade medel (botar, skript m.m.). Användningen av betalplaner omfattas av en gräns för skälig användning (för närvarande 60 sessioner per kalendermånad), som närmare anges i distansavtalet.",
        ],
      },
      {
        heading: "4. Allt ansvar vilar på Användaren (ansvarsfriskrivning)",
        paras: [
          "Plattformen tillhandahålls ”I BEFINTLIGT SKICK” och ”I MÅN AV TILLGÅNG”, utan någon som helst uttrycklig eller underförstådd garanti (inklusive oavbruten drift, frihet från fel, lämplighet för ett visst ändamål, riktighet eller aktualitet).",
          "Användaren godtar och åtar sig att hen är UTESLUTANDE och PERSONLIGEN ansvarig för alla direkta, indirekta, oförutsedda, särskilda skador eller följdskador (inklusive materiella och ideella skador, skador på yrkesmässigt anseende, dataförlust, intäktsförlust och skador som orsakas tredje part) som uppstår till följd av användningen av, eller oförmågan att använda, Plattformen, av att förlita sig på AI-resultat eller av att tillämpa sådana resultat på något sätt.",
          "I den utsträckning tillämplig lag tillåter AVSTÅR Användaren härmed oåterkalleligt och villkorslöst, nu och på förhand, från alla anspråk, rättsliga åtgärder och rätt till ersättning som hen skulle kunna rikta mot Plattformen, dess ägare, anställda, utvecklare, affärspartner och tjänsteleverantörer med anledning av skada hen kan drabbas av vid ett ogynnsamt utfall.",
          "Användaren åtar sig vidare att hålla Plattformen helt skadeslös från alla anspråk, skador, påföljder och kostnader (inklusive ombudsarvoden) om Plattformen skulle kontaktas av någon tredje part eller institution på grund av Användarens eget fel, vårdslöshet eller användning i strid med dessa Villkor.",
        ],
      },
      {
        heading: "5. Ansvarsbegränsning",
        paras: [
          "Utan att det påverkar tvingande bestämmelser i tillämplig lag ska Plattformens totala rättsliga ansvar under alla omständigheter vara begränsat till det belopp som Användaren faktiskt betalat till Plattformen under de 12 månader som föregick den händelse som gav upphov till anspråket. Vid kostnadsfri användning är detta belopp noll.",
        ],
      },
      {
        heading: "6. Immateriella rättigheter, ändringar och uppsägning",
        bullets: [
          "Alla immateriella rättigheter till Plattformen, dess programvara, design, patientfallsmallar och innehåll tillhör Plattformen.",
          "Alla överlåtbara ekonomiska immateriella rättigheter till innehåll som Användaren skapar på Plattformen (inklusive de terapeutmeddelanden hen skriver, sessionsutskrifter och material som härleds ur dem) anses överlåtna till Plattformen exklusivt, för all framtid och utan ersättning i det ögonblick innehållet skapas; Plattformen får använda, mångfaldiga och bearbeta detta innehåll i hela världen och utan begränsning för alla ändamål, inklusive att driva tjänsten, generera återkoppling samt förbättra och utveckla systemet (inklusive förbättring genom maskininlärning). Användarens rättigheter avseende personuppgifter enligt tillämplig dataskyddslagstiftning (GDPR / KVKK) påverkas inte av denna överlåtelse och förblir förbehållna.",
          "Plattformen förbehåller sig rätten att när som helst, utan föregående meddelande, ändra, tillfälligt avbryta eller upphöra med dessa Villkor och tjänstens omfattning.",
          "Vid brott mot dessa Villkor kan Plattformen stänga av eller avsluta kontot utan föregående meddelande.",
        ],
      },
      {
        heading: "7. Tillämplig lag och behörig domstol",
        paras: [
          "Dessa Villkor regleras av Republiken Türkiyes lagar. Republiken Türkiyes domstolar och kronofogdemyndigheter är behöriga vid varje tvist som kan uppstå.",
          "För konsumenter bosatta i Europeiska unionen förbehålls det skydd som följer av tvingande konsumentskyddsbestämmelser i deras bosättningsland och av deras dataskyddsrättigheter enligt GDPR; detta lagval åsidosätter inte dessa tvingande bestämmelser.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Integritetspolicy",
    description:
      "GDPR som grundstandard; behandlade uppgifter, rättsliga grunder, hosting i EU, internationella överföringar (AI-leverantör) samt klausulen om överföring utomlands enligt KVKK art. 9 för användare i Türkiye.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `Denna Integritetspolicy förklarar hur personuppgifter behandlas inom den Plattform som drivs av ${OWNER}. Som grundläggande dataskyddsstandard följer policyn EU:s allmänna dataskyddsförordning (GDPR / 2016/679); för användare i Türkiye tillämpas dessutom den turkiska personuppgiftslagen nr 6698 (KVKK), särskilt artikel 9 om överföring utomlands. KVKK-informationen och Förklaringen om uttryckligt samtycke utgör integrerade delar av denna policy.`,
        ],
      },
      {
        heading: "Personuppgiftsansvarig och hostingplats",
        bullets: [
          "Personuppgiftsansvarig: PsyPractice. Registrerades begäranden hanteras via den kontaktkanal som anges på Plattformen (kontakt-e-post: info@psycora.com).",
          "Hosting: Plattformen och dess databas hostas inom Europeiska unionen, i ett datacenter i Nederländerna (Oracle Cloud). För användare i EU/EES behandlas och lagras uppgifterna inom EU.",
          "Hostingleverantören agerar enbart som personuppgiftsbiträde, enligt ett ingånget personuppgiftsbiträdesavtal (DPA).",
        ],
      },
      {
        heading: "Uppgifter som samlas in",
        bullets: [
          "Kontouppgifter: namn, e-post, hashat lösenord, prenumerations-/planuppgifter.",
          "Användningsuppgifter: skapade sessioner, sessionsutskrifter, genererade patientfall, handledarens återkopplingsrapporter.",
          "Tekniska uppgifter: sessionsloggar, IP, webbläsar-/språkinställning, loggar för hastighetsbegränsning och säkerhet.",
        ],
      },
      {
        heading: "Ändamål med behandlingen och rättslig grund (GDPR art. 6)",
        bullets: [
          "Fullgörande av avtal (art. 6.1 b): skapande av konto, genomförande av sessioner, patientminne över flera sessioner, handledarbedömning, hantering av prenumeration och användningsgränser.",
          "Berättigat intresse (art. 6.1 f): säkerhet, förebyggande av missbruk, systemförbättring och felsökning.",
          "Rättslig förpliktelse (art. 6.1 c): lagring/rapportering som följer av lagstiftning.",
          "Samtycke (art. 6.1 a): analys-/produktförbättringsbehandling som inte är strikt nödvändig för tjänsten samt, där så krävs, överföring utanför EU/EES.",
        ],
      },
      {
        heading: "Internationella överföringar",
        paras: [
          "Eftersom hostingen sker inom EU (Nederländerna) behandlas uppgifter om användare i EU/EES i regel inom EU, utan överföring till tredjeland i det ledet. För att generera AI-svar överförs dock sessionsinnehåll och prompter till AI-tjänsteleverantören (Anthropic), vars behandlingsinfrastruktur kan vara belägen utanför EU/EES (t.ex. i USA).",
          "Sådana överföringar utanför EU/EES stöder sig på lämpliga skyddsåtgärder enligt GDPR art. 44 och följande, särskilt Europeiska kommissionens standardavtalsklausuler (SCC), och ett personuppgiftsbiträdesavtal (DPA) ingås med leverantören. Plattformen SÄLJER INTE personuppgifter för marknadsföringsändamål; uppgifter delas inte med tredje part utom när det är strikt nödvändigt för att driva tjänsten (lagenliga begäranden från behöriga myndigheter förbehålls).",
        ],
      },
      {
        heading: "För användare i Türkiye: KVKK art. 9 (överföring utomlands)",
        paras: [
          "Personuppgifter om användare i Türkiye överförs utanför Türkiye eftersom hostingen sker i Nederländerna (EU), och kan även överföras till Anthropic för AI-behandling. Dessa överföringar omfattas av KVKK art. 9 och stöder sig på lämpliga skyddsåtgärder (det standardavtal / åtagande som Nämnden publicerat) eller, där så krävs, på ditt uttryckliga samtycke. Överföringens omfattning, mottagare och ändamål beskrivs närmare i KVKK-informationen och Förklaringen om uttryckligt samtycke.",
        ],
      },
      {
        heading: "Den registrerades rättigheter (GDPR art. 15 till 22)",
        bullets: [
          "Tillgång, rättelse, radering (”rätten att bli bortglömd”) och begränsning av behandling.",
          "Dataportabilitet: att få de uppgifter du lämnat i ett strukturerat, allmänt använt och maskinläsbart format.",
          "Invändning: att invända mot behandling som grundas på berättigat intresse och mot direktmarknadsföring.",
          "Rättigheter som rör helt automatiserat individuellt beslutsfattande/profilering.",
          "Att när som helst återkalla samtycke för samtyckesbaserad behandling (återkallelsen påverkar inte lagligheten av behandling som skett dessförinnan).",
          "Rätten att lämna in klagomål till en tillsynsmyndighet: den relevanta dataskyddsmyndigheten i EU; Myndigheten för skydd av personuppgifter (KVKK) i Türkiye.",
        ],
      },
      {
        heading: "Lagring och säkerhet",
        bullets: [
          "Uppgifter lagras så länge behandlingens ändamål kräver det och under de perioder som tillämplig lag föreskriver; när perioden löpt ut raderas eller anonymiseras de.",
          "Känsliga fält (t.ex. lösenord samt verifierings- och återställningskoder) hålls krypterade/hashade; åtkomsten är behörighetsstyrd.",
          "Eftersom ingen överförings- eller lagringsmetod är 100 % säker kan absolut säkerhet inte garanteras.",
        ],
      },
      {
        heading: "Förbud mot verkliga patientuppgifter",
        paras: [
          "Plattformen är en simuleringsprogramvara; det är förbjudet att mata in person- eller hälsouppgifter som tillhör verkliga klienter. Allt ansvar som uppstår genom att Användaren matar in uppgifter i strid med detta förbud vilar uteslutande på Användaren.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "KVKK-information",
    description:
      "Personuppgiftsansvarig, ändamål med behandlingen, rättslig grund, överföring och den registrerades rättigheter enligt artikel 10 i lag nr 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Personuppgiftsansvarig",
        paras: [
          `I enlighet med artikel 10 i den turkiska personuppgiftslagen nr 6698 (”KVKK”) behandlas dina personuppgifter av ${OWNER} i egenskap av Personuppgiftsansvarig, inom den omfattning som beskrivs nedan.`,
        ],
      },
      {
        heading: "Behandlade uppgifter och ändamål",
        bullets: [
          "Identitet/kontakt (namn, e-post): skapande av konto, autentisering, kommunikation.",
          "Kundtransaktioner (prenumeration, plan, användning): tillhandahållande av tjänsten, fakturering, tillämpning av gränser.",
          "Transaktionssäkerhet (session, IP, loggar): säkerhet, förebyggande av missbruk, rättslig förpliktelse.",
          "Användarinnehåll (sessionsutskrifter, genererade fall): tillhandahållande av programvarutjänsten och generering av återkoppling.",
          "Medlemskap i institutionell kohort (kohortidentifierare, medlemskapsperiod): när användaren går med i en kohort som drivs av en institution, instruktörens insyn och administration av kohorten.",
        ],
      },
      {
        heading: "Rättslig grund (art. 5)",
        bullets: [
          "Ingående/fullgörande av avtal: uppgifter som är nödvändiga för att tillhandahålla tjänsten.",
          "Den personuppgiftsansvariges berättigade intresse: säkerhet, förebyggande av bedrägeri, systemförbättring.",
          "Rättslig förpliktelse: lagring/rapportering som följer av lagstiftning.",
          "Uttryckligt samtycke: överföring utomlands (art. 9) och ytterligare behandling som inte är strikt nödvändig för tjänsten.",
        ],
      },
      {
        heading: "Överföring utomlands (art. 9)",
        paras: [
          "Eftersom Plattformen och dess databas hostas inom Europeiska unionen, i ett datacenter i Nederländerna (Oracle Cloud), överförs personuppgifter om användare i Türkiye utanför Türkiye (till EU). För att generera AI-svar kan dessutom sessionsinnehåll och prompter överföras till AI-tjänsteleverantören (Anthropic), vars behandlingsinfrastruktur kan vara belägen utanför EU/EES (t.ex. i USA).",
          "Dessa överföringar utomlands omfattas av KVKK art. 9 och stöder sig på lämpliga skyddsåtgärder, såsom det standardavtal / åtagande som Nämnden publicerat, eller, där så krävs, på ditt uttryckliga samtycke. Personuppgiftsbiträdesavtal (DPA) ingås med hosting- och tjänsteleverantörerna.",
        ],
      },
      {
        heading: "Institutionella kohorter och instruktörens insyn",
        paras: [
          "Om du går med i en kohort som öppnats av ett universitet, en klinik eller en liknande institution kan ditt sessionsinnehåll (utskrifter) och dina handledarrapporter ses av kohortens instruktör under kohortens varaktighet. Denna insyn omfattar endast dina sessioner som är knutna till kohorten och upphör när ditt kohortmedlemskap upphör.",
          "Denna åtkomst inhämtas via en SEPARAT skärm för uttryckligt samtycke som visas när du går med i kohorten; den ingår inte i Plattformens allmänna godkännande. Om du inte ger det samtycket kan du inte gå med i kohorten, men du kan fortsätta använda Plattformen individuellt precis som tidigare. Att återkalla samtycket avslutar ditt kohortmedlemskap och lämnar din individuella användning opåverkad.",
        ],
      },
      {
        heading: "Den registrerades rättigheter (art. 11)",
        bullets: [
          "Att få veta om dina personuppgifter behandlas och, i så fall, att begära information.",
          "Att få veta ändamålet med behandlingen och om uppgifterna används i enlighet med det ändamålet.",
          "Att få veta vilka tredje parter uppgifterna överförs till inom landet eller utomlands.",
          "Att begära rättelse av ofullständig/felaktig behandling och, när villkoren är uppfyllda, radering/förstöring.",
          "Att invända mot ett resultat till din nackdel som uppstått enbart genom automatiserad analys.",
          "Att begära ersättning för skada som lidits på grund av olaglig behandling.",
        ],
      },
      {
        heading: "Begäranden",
        paras: [
          "Du kan lämna in begäranden rörande dina rättigheter via den kontaktkanal som den Personuppgiftsansvarige anger. Begäranden avgörs inom de tidsfrister som föreskrivs i KVKK och dess sekundärlagstiftning.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Förklaring om uttryckligt samtycke",
    description:
      "Separat från informationen; frivilligt lämnat samtycke till överföring utomlands och AI-behandling.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Jag förklarar att jag har läst och förstått KVKK-informationen och att jag frivilligt, informerat och uttryckligt samtycker till den behandling som beskrivs nedan. (Enligt KVKK-nämndens beslut nr 2018/90 inhämtas uttryckligt samtycke separat från informationsskyldigheten.)",
        ],
      },
      {
        heading: "Behandling som samtycke lämnas till",
        bullets: [
          "Överföring av mina personuppgifter utanför Türkiye, samt lagring och behandling av dem där, eftersom Plattformen hostas inom Europeiska unionen (Nederländerna / Oracle Cloud) (KVKK art. 9).",
          "Överföring och behandling av mina sessionsutskrifter och prompter hos AI-tjänsteleverantören (Anthropic), vars behandlingsinfrastruktur kan vara belägen utanför EU/EES, i syfte att generera AI-svar (KVKK art. 9).",
          "Behandling för produktförbättring och analys som inte är strikt nödvändig för att tillhandahålla tjänsten.",
          "Mottagande av tjänsterelaterade aviseringar.",
        ],
      },
      {
        heading: "Återkallelse av samtycke",
        paras: [
          "Jag förstår att jag när som helst kan återkalla mitt uttryckliga samtycke; eftersom överföringen utomlands till AI-leverantören är tekniskt nödvändig för att tjänsten ska fungera, godtar jag dock att en återkallelse av detta samtycke kan leda till att jag inte kan använda de berörda funktionerna eller tjänsten som helhet. Återkallelsen påverkar inte lagligheten av behandling som utförts fram till dagen för återkallelsen.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice: see the comment there.
    id: "outreach",
    title: "Information om uppsökande kontakt",
    description:
      "För akademiker och institutionella kontakter som fått ett uppsökande e-postmeddelande från företaget: varifrån uppgifterna kommer, varför de behandlas, den rättsliga grunden och hur man avböjer.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "Denna information riktar sig till mottagare av uppsökande e-postmeddelanden som PsyPractice skickar till universitetens psykologiska institutioner och deras akademiska personal, i enlighet med artikel 10 i den turkiska personuppgiftslagen nr 6698 (KVKK) och kommunikén om förfaranden och principer för fullgörande av informationsskyldigheten. Eftersom dina personuppgifter inte inhämtades direkt från dig lämnas informationen senast vid den första kontakten, vilket är anledningen till att e-postmeddelandet länkar hit.",
        ],
      },
      {
        heading: "1. Personuppgiftsansvarig",
        bullets: [
          `Namn: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adress: ${MERCHANT.addressEn}`,
          `Skattekontor / nr: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-post: ${MERCHANT.email}`,
          `Webb: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Behandlade uppgifter och deras källa",
        paras: [
          "Behandlingen är begränsad till yrkesmässiga kontaktuppgifter: namn, akademisk titel, universitet och institution, institutionell e-postadress och, där den är publicerad, institutionellt telefonnummer.",
          "Dessa uppgifter samlades inte in från dig utan sammanställdes från universitetens offentligt publicerade officiella institutions- och fakultetssidor. Inga känsliga personuppgifter behandlas, och privata (icke-institutionella) e-postadresser används inte för uppsökande kontakt.",
        ],
      },
      {
        heading: "3. Ändamål",
        paras: [
          "Dina uppgifter behandlas för att presentera ett programvaruverktyg byggt för psykologiämnet, för att bjuda in din institution till ett möjligt samtal om ett pilotprojekt eller ett samarbete, och för att sköta den korrespondens som hör till detta. De används inte för något annat ändamål, säljs inte och överförs inte till tredje part för marknadsföring.",
        ],
      },
      {
        heading: "4. Rättslig grund",
        paras: [
          "Behandlingen stöder sig på den personuppgiftsansvariges berättigade intressen enligt artikel 5/2-(f) KVKK, under förutsättning att detta inte skadar dina grundläggande fri- och rättigheter: kontakt tas endast till en institutionell adress, endast i en fråga som direkt rör mottagarens yrkesområde, och ett begränsat antal gånger.",
          "Enbart det faktum att uppgifter är offentligt tillgängliga på nätet utgör inte i sig en rättslig grund. Nämnden för skydd av personuppgifter har slagit fast att uppgifters offentlighet inte gör dem användbara för alla ändamål, och att avsikten med och syftet bakom offentliggörandet måste bedömas separat; artikel 5/2-(d) åberopas därför inte.",
        ],
      },
      {
        heading: "5. Överföringar och lagring",
        paras: [
          "Korrespondensen sköts via en e-postleverantör vars infrastruktur kan vara belägen utomlands; sådana överföringar sker med lämpliga skyddsåtgärder enligt artikel 9 KVKK.",
          "Dina uppgifter raderas när kontaktens ändamål upphör eller på din begäran. Efter en begäran om radering behålls endast en strikt begränsad ”kontakta inte”-post enbart för att säkerställa att du inte kontaktas igen; den används aldrig för uppsökande kontakt.",
        ],
      },
      {
        heading: "6. Kommersiella elektroniska meddelanden och rätten att avböja",
        paras: [
          "Marknadsföringsmeddelanden omfattas av lag nr 6563 om reglering av elektronisk handel. Du kan avböja att ta emot dem utan att ange något skäl; avböjanden hanteras inom högst tre arbetsdagar, varefter inga ytterligare marknadsföringsmeddelanden skickas. Det räcker att svara på det e-postmeddelande du fått eller att skriva till " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Dina rättigheter",
        paras: [
          "Enligt artikel 11 KVKK har du rätt att få veta om dina personuppgifter behandlas, att begära information om dem, att få veta ändamålet med behandlingen och om de används i enlighet med det, att få veta vilka tredje parter de överförs till i Turkiet eller utomlands, att begära rättelse av ofullständiga eller felaktiga uppgifter, att begära radering eller förstöring, att begära att dessa åtgärder meddelas tredje parter, att invända mot ett resultat till din nackdel som uppstått enbart genom automatiserad analys, och att begära ersättning för skada som lidits.",
          `Begäranden kan skickas till ${MERCHANT.email} och besvaras inom högst trettio dagar. Du behåller även rätten att lämna in klagomål till Nämnden för skydd av personuppgifter.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Cookiepolicy",
    description: "Typer av cookies som används, deras ändamål och hantering av inställningar.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Plattformen använder cookies och liknande tekniker för lokal lagring (localStorage) för att upprätthålla din session och komma ihåg dina inställningar.",
        ],
      },
      {
        heading: "Tekniker som används",
        bullets: [
          "Strikt nödvändiga: sessions-/autentiseringstoken, säkerhet. Tjänsten fungerar inte utan dessa.",
          "Funktionella: språk-/regioninställning (NEXT_LOCALE), gränssnittsinställningar (t.ex. tema).",
          "Prestanda/säkerhet: tekniska loggar för hastighetsbegränsning och upptäckt av missbruk.",
        ],
      },
      {
        heading: "Hantering av inställningar",
        paras: [
          "Du kan radera eller blockera cookies i din webbläsare; att blockera strikt nödvändiga cookies hindrar dock inloggning och kärnfunktioner. I linje med principerna i GDPR / ePrivacy och KVKK:s cookievägledning används icke-nödvändiga cookies endast på grundval av din uttryckliga inställning/ditt samtycke.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Om oss",
    description:
      "PsyPractices syfte, den tjänst som erbjuds samt säljarens (näringsidkarens) kontaktuppgifter.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "PsyPractice är en AI-stödd plattform för patientsimulering och kliniska färdigheter, byggd för psykologstudenter och nyexaminerade kliniker i början av karriären. Användarna genomför textbaserade terapisessioner; i slutet av varje session bedömer en handledar-AI samtalet och tar fram en utvecklande återkopplingsrapport. Patient-AI:n för den terapeutiska relationen vidare session för session genom minne över flera sessioner.",
        ],
      },
      {
        heading: "Vårt uppdrag",
        paras: [
          "Vårt mål är att ge framtidens yrkesverksamma inom psykisk hälsa en trygg, upprepningsbar miljö där de kan öva samtalsfärdigheter utan någon risk att skada verkliga klienter. PsyPractice är inte en utbildnings- eller undervisningstjänst; det är ett programvaruverktyg som låter användaren genomföra och dokumentera sin egen övning. Det är inte verklig terapi eller rådgivning, det ersätter inte klinisk handledning, det är inte ett diagnostiskt instrument eller bedömningsinstrument, och det får inte användas i kriser eller nödsituationer.",
        ],
      },
      {
        heading: "Vad vi erbjuder",
        bullets: [
          "Simulering av textbaserade terapisessioner med en mängd olika patientprofiler som syntetiserats ur klinisk litteratur.",
          "Automatiserade handledarrapporter med bedömning efter varje session.",
          "En ”levande patient”-modell med minne över flera sessioner som utvecklar den terapeutiska relationen över tid.",
          "Skapande av egna patienter, så att studenter kan skapa sina egna AI-fall.",
          "Utvecklingsmått som följer mikrofärdigheternas utveckling.",
        ],
      },
      {
        heading: "Säljare / företagsuppgifter",
        bullets: [
          `Firma: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Adress: ${MERCHANT.addressEn}`,
          `Skattekontor / nr: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-post: ${MERCHANT.email}`,
          `Webb: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Distansavtal",
    description:
      "Villkor om säljare, köpare, tjänst, pris, betalning, fullgörande och ångerrätt enligt turkisk lag nr 6502 och förordningen om distansavtal.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Parter",
        bullets: [
          `SÄLJARE: ${MERCHANT.legalName} (${OWNER_TYPE}). Adress: ${MERCHANT.addressEn}. Skattekontor/nr: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-post: ${MERCHANT.email}.`,
          "KÖPARE: den fysiska eller juridiska person som skapar ett konto på Plattformen och köper en betald prenumeration (”Köparen”).",
        ],
      },
      {
        heading: "2. Avtalets föremål",
        paras: [
          "Detta Avtal har till föremål att fastställa parternas rättigheter och skyldigheter, i enlighet med turkisk lag nr 6502 om konsumentskydd och förordningen om distansavtal, avseende försäljning och fullgörande av den digitala tjänsteprenumeration som Köparen köper elektroniskt via Plattformen, vars egenskaper och försäljningspris anges nedan.",
        ],
      },
      {
        heading: "3. Tjänstens karaktär och pris",
        bullets: [
          "Den tjänst som säljs är de AI-stödda patientsimuleringsfunktioner som erbjuds under en betald prenumerationsplan i programvaran PsyPractice (en digital tjänst / rätt att använda programvaran).",
          "PsyPractice är inte en utbildnings- eller undervisningstjänst; det är ett programvaruverktyg som låter användaren genomföra och dokumentera sin egen övning. Prenumerationsavgiften är ersättning för åtkomst till den programvaran; den är inte en avgift för lektioner, läroplan, examinationer, rådgivning eller något dokument.",
          "Planens innehåll, löptid (månadsvis, en period om 4 månader eller årsvis) och aktuellt pris visas tydligt på Plattformens pris-/betalsida vid köptillfället; det totala beloppet inklusive skatter meddelas Köparen före betalning.",
          "Priserna gäller i den valuta som visas på Plattformen; om prenumerationen inte sägs upp förnyas den automatiskt till samma pris vid utgången av den valda löptiden.",
          "För planer som erbjuds som ”obegränsade sessioner” omfattas användningen av en gräns för skälig användning (för närvarande 60 sessioner per kalendermånad). När gränsen har nåtts kan nya sessioner påbörjas igen från den första dagen i följande kalendermånad; detta ger inte rätt till prisavdrag eller återbetalning. Gränsen finns för att förhindra kontodelning och automatiserad användning, och Säljaren ändrar den inte till Köparens nackdel under en betald abonnemangsperiod.",
        ],
      },
      {
        heading: "4. Betalning",
        paras: [
          "Betalningar tas emot säkert med kredit-/betalkort via det licensierade betalningsinstitutet iyzico. Kortuppgifter lagras inte av Säljaren; betalningen behandlas via iyzicos säkra system. För återkommande (prenumerations-) betalningar debiteras beloppet automatiskt varje förnyelseperiod från det kort som Köparen godkänt.",
        ],
      },
      {
        heading: "5. Fullgörande och leverans",
        paras: [
          "Tjänsten är digital och innebär ingen fysisk leverans. När betalningen bekräftats görs prenumerationsfunktionerna omedelbart tillgängliga i Köparens konto. Fullgörandet sker elektroniskt genom att oavbruten åtkomst tillhandahålls under hela prenumerationsperioden.",
        ],
      },
      {
        heading: "6. Ångerrätt och dess undantag",
        bullets: [
          "Enligt artikel 15/1-(ğ) i förordningen om distansavtal kan ångerrätten inte utövas för immateriella (digitala) varor/tjänster som fullgörs omedelbart i elektronisk form, när fullgörandet påbörjats med Köparens samtycke.",
          "Köparen bekräftar vid köptillfället att tjänsten kommer att fullgöras omedelbart och att det därför inte finns någon ångerrätt. Köparen kan när som helst säga upp prenumerationen för att stoppa förnyelsen; uppsägningen får verkan vid utgången av den innevarande betalda perioden.",
          "För detaljerade återbetalningsvillkor, se ”Leverans- och återbetalningsvillkor”.",
        ],
      },
      {
        heading: "7. Tvister och ikraftträdande",
        paras: [
          "Vid tvist kan Köparen vända sig till konsumentnämnden eller konsumentdomstolarna på sin bosättningsort inom de beloppsgränser som Handelsministeriet tillkännager. Detta Avtal ingås och träder i kraft när Köparen godkänner det i elektronisk form.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Leverans- och återbetalningsvillkor",
    description:
      "Leverans av den digitala tjänsten, uppsägning av prenumeration, undantaget från ångerrätten och villkor för återbetalning.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Leverans (digital tjänst)",
        bullets: [
          "PsyPractice är en helt digital tjänst; det förekommer ingen fysisk produktleverans eller budleverans.",
          "I det ögonblick betalningen bekräftas aktiveras prenumerationsfunktionerna automatiskt och omedelbart i Köparens konto; det finns ingen separat leveranstid eller leveransavgift.",
          "Tjänsten nås via webbläsaren på valfri enhet med internetanslutning.",
        ],
      },
      {
        heading: "Uppsägning av prenumeration",
        bullets: [
          "Köparen kan när som helst säga upp prenumerationen från kontoinställningarna. Uppsägningen får verkan vid utgången av den innevarande betalda perioden och stoppar nästa automatiska förnyelse.",
          "Efter uppsägningen fortsätter åtkomsten till tjänsten under återstoden av den betalda perioden.",
        ],
      },
      {
        heading: "Ångerrätt och återbetalning",
        bullets: [
          "Eftersom tjänsten är en digital tjänst som fullgörs omedelbart med Köparens samtycke uppstår i regel ingen ångerrätt, och därmed ingen rätt till återbetalning, enligt artikel 15/1-(ğ) i förordningen om distansavtal.",
          "Vid tydliga fel såsom felaktig/dubbel debitering, fullständig oförmåga att få åtkomst till tjänsten av tekniska skäl eller liknande kan Köparen begära återbetalning genom att kontakta Säljaren inom rimlig tid från betalningsdatumet.",
          `Begäranden om återbetalning skickas till ${MERCHANT.email}; godkända återbetalningar återförs till det kort som användes vid betalningen via iyzicos infrastruktur, i regel inom 14 dagar. Återbetalningstiden kan variera beroende på bankens handläggningstid.`,
        ],
      },
      {
        heading: "Kontakt",
        paras: [
          `För alla frågor om leverans, uppsägning och återbetalning: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
